import ConfirmEmailView from "components/ConfirmEmail/ConfirmEmail";
import AboutUs from "components/Plain/AboutUs";
import CookiePolicy from "components/Plain/CookiePolicy";
import PrivacyPolicy from "components/Plain/PrivacyPolicy";
import TermsOfService from "components/Plain/TermsOfService";
import StatisticsDashboard from "containers/Admin/Statistics/Dashboard";
import Users from "containers/Admin/User/Users";
import EditWebinar from "containers/Admin/Webinar/EditWebinar";
import NewsletterUsersContainer from "containers/Admin/Webinar/NewsletterUsersContainer";
import RegisteredUserForWebinar from "containers/Admin/Webinar/RegisteredUsers.jsx";
import Webinars from "containers/Admin/Webinar/Webinars";
import App from "containers/App/App";
import ForgotPassword from "containers/Authorization/ForgotPassword/ForgotPassword";
import Login from "containers/Authorization/Login/Login";
import NewPassword from "containers/Authorization/NewPassword/NewPassword";
import SignUp from "containers/Authorization/SignUp/SignUp";
import ConfirmEmail from "containers/ConfirmEmail/ConfirmEmail";
import CpdLive from "containers/CpdLocker/CpdLive";
import CpdLocker from "containers/CpdLocker/CpdLocker";
import CpdRecorded from "containers/CpdLocker/CpdRecorded";
import Dashboard from "containers/Dashboard/Dashboard";
import JoinWebinar from "containers/JoinWebinar";
import Landing from "containers/Landing/Landing";
import Profile from "containers/Profile/Profile";
import OnlineWebinar from "containers/Webinar/OnlineWebinar.jsx";
import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { IndexRoute, Redirect, Route } from "react-router";
import { ReduxRouter } from "redux-router";

import ApproveBooking from "containers/Admin/Calendar/ApprovedBooking.jsx";
import PendingBooking from "containers/Admin/Calendar/PendingBooking";
import RejectedBooking from "containers/Admin/Calendar/RejectedBooking";
import ApproveUsers from "containers/Admin/User/ApproveDisciplines/ApproveDisciplines.jsx";
import ApproveIpna from "containers/Admin/User/ApproveIpna/ApproveIpna.jsx";
import EditUser from "containers/Admin/User/EditUser";
import NewUser from "containers/Admin/User/NewUser";
import NovoNordiskUsersContainer from "containers/Admin/User/NovoNordiskUsers/NovoNordiskUsers";
import NewWebinar from "containers/Admin/Webinar/NewWebinar";
import SponsorBookings from "containers/Calendar/SponsorBookings";
import FeedbackContainer from "containers/Feedback/Feedback";

import AddUsersWebinar from "containers/AddUsersWebinar/AddUsersWebinar";
import EditAddUsersWebinar from "containers/AddUsersWebinar/EditAddUsersWebinar";

import Disciplines from "containers/Admin/Discipline/Disciplines";
import Partners from "containers/Admin/Partner/Partners";
import Sponsors from "containers/Admin/Sponsor/Sponsors";
import SponsorsDashboard from "containers/SponsorsDashboard";

import SponsorsRouteInterceptor from "components/SponsorsRouteInterceptor";
import EditDiscipline from "containers/Admin/Discipline/EditDiscipline";
import NewDiscipline from "containers/Admin/Discipline/NewDiscipline";
import EditSponsor from "containers/Admin/Sponsor/EditSponsor";
import NewSponsor from "containers/Admin/Sponsor/NewSponsor";

import EditPartner from "containers/Admin/Partner/EditPartner";
import NewPartner from "containers/Admin/Partner/NewPartner";

import CalendarSponsor from "containers/Calendar/Calendar";
// import CalendarAdmin from 'containers/Admin/NewCalendarAdmin/CalendarAdmin'

import actions from "actions";
import AdminSettings from "containers/Admin/Settings/Settings";
import EditUserSponsor from "containers/Admin/UserSponsors/EditUserSponsor";
import NewUserSponsor from "containers/Admin/UserSponsors/NewUserSponsor";
import UsersSponsors from "containers/Admin/UserSponsors/UsersSponsors";
import EditCalendar from "containers/Calendar/EditCalendar";
import Unsubscribe from "./containers/Mail/Unsubscribe";

import StudyGroupSuperhostAddWebinar from "./components/StudyGroupSuperhost/StudyGroupSuperhostAddWebinar";
import StudyGroupSuperhostAddWebinarUsers from "./components/StudyGroupSuperhost/StudyGroupSuperhostAddWebinar/StudyGroupSuperhostAddWebinarUsers";
import StudyGroupSuperhostEditMaterialForm from "./components/StudyGroupSuperhost/StudyGroupSuperhostEditMaterialForm";
import StudyGroupSuperhostEditWebinar from "./components/StudyGroupSuperhost/StudyGroupSuperhostEditWebinar";
import StudyGroupSuperhostInviteMembers from "./components/StudyGroupSuperhost/StudyGroupSuperhostInviteMembers";
import StudyGroupSuperhostMaterials from "./components/StudyGroupSuperhost/StudyGroupSuperhostMaterials";
import StudyGroupSuperhostMembers from "./components/StudyGroupSuperhost/StudyGroupSuperhostMembers";
import StudyGroupSuperhostMembersInvitations from "./components/StudyGroupSuperhost/StudyGroupSuperhostMembersInvitations";
import StudyGroupSuperhostStatistic from "./components/StudyGroupSuperhost/StudyGroupSuperhostStatistic";
import StudyGroupSuperhostWebinar from "./components/StudyGroupSuperhost/StudyGroupSuperhostWebinar";
import StudyGroupSuperhostWebinarFeedback from "./components/StudyGroupSuperhost/StudyGroupSuperhostWebinarFeedback";
import StudyGroupSuperhostWebinars from "./components/StudyGroupSuperhost/StudyGroupSuperhostWebinars";
import StudyGroupSuperhostWebinarsWrapper from "./components/StudyGroupSuperhost/StudyGroupSuperhostWebinarsWrapper";
import StudyGroupSuperhostCurrentWebinars from "./components/StudyGroupSuperhost/Webinars/Current/StudyGroupSuperhostCurrentWebinars";
import StudyGroupSuperhostRecordedWebinars from "./components/StudyGroupSuperhost/Webinars/Recorded/StudyGroupSuperhostRecordedWebinars";
import StudyGroupSuperhostUpcomingWebinars from "./components/StudyGroupSuperhost/Webinars/Upcoming/StudyGroupSuperhostUpcomingWebinars";
import StudyGroupUserChat from "./components/StudyGroupsUser/StudyGroupUserChat";
import StudyGroupUserMaterials from "./components/StudyGroupsUser/StudyGroupUserMaterials";
import StudyGroupUserMaterialsNew from "./components/StudyGroupsUser/StudyGroupUserMaterialsNew";
import StudyGroupUserMembers from "./components/StudyGroupsUser/StudyGroupUserMembers";
import StudyGroupUserWebinars from "./components/StudyGroupsUser/StudyGroupUserWebinars";
import FeedbackEdit from "./containers/Admin/FeedbackEdit/FeedbackEdit.js";
import EditStudyGroup from "./containers/Admin/StudyGroups/EditStudyGroup";
import GroupMembers from "./containers/Admin/StudyGroups/GroupMembers";
import NewStudyGroup from "./containers/Admin/StudyGroups/NewStudyGroup";
import StudyGroupPage from "./containers/Admin/StudyGroups/StudyGroupPage";
import StudyGroups from "./containers/Admin/StudyGroups/StudyGroups";
import EditSuperhost from "./containers/Admin/Superhosts/EditSuperhost";
import NewSuperhost from "./containers/Admin/Superhosts/NewSuperhost";
import Superhosts from "./containers/Admin/Superhosts/Superhosts";
import FAQPageContainer from "./containers/FAQ/FaqPage";
import GuestSearchPage from "./containers/GuestSearchPage/GuestSearchPage";
import JoinQRCodeWebinar from "./containers/JoinQRCodeWebinar";
import ProfileRepresentative from "./containers/RepresentativeProfile";
import Search from "./containers/SearchPage/SearchPage";
import DataVisualisation from "./containers/StatsLocker/DataVisualisation";
import StatsLocker from "./containers/StatsLocker/StatsLocker";
import StudyGroupSuperHostPage from "./containers/StudyGroupSuperHostPage";
import StudyGroupsListUser from "./containers/StudyGroups";
import StudyGroupUserPage from "./containers/StudyGroups/StudyGroupUserPage";
import StudyGroupsSuperhost from "./containers/StudyGroupsSuperhost";

import NewGroupWebinar from "containers/Admin/StudyGroups/NewGroupWebinar";
import RepresentiveNotPendingRequests from "./components/RepresentiveRequests/RepresentiveNotPendingRequests.jsx";
import RepresentivePendingRequests from "./components/RepresentiveRequests/RepresentivePendingRequests.jsx";
import StudyGroupUserWebinar from "./components/StudyGroupsUser/StudyGroupUserWebinar";
import StudyGroupUserWebinarFeedback from "./components/StudyGroupsUser/StudyGroupUserWebinarFeedback";
import StudyGroupUserCurrentWebinars from "./components/StudyGroupsUser/StudyGroupUserWebinars/Current/StudyGroupUserCurrentWebinars";
import StudyGroupUserRecordedWebinars from "./components/StudyGroupsUser/StudyGroupUserWebinars/Recorded/StudyGroupUserRecordedWebinars";
import StudyGroupUserUpcomingWebinars from "./components/StudyGroupsUser/StudyGroupUserWebinars/Upcoming/StudyGroupUserUpcomingWebinars";
import AddGroupMembers from "./containers/Admin/StudyGroups/AddGroupMembers";
import CourseMaterials from "./containers/Admin/StudyGroups/CourseMaterials";
import EditGroupWebinar from "./containers/Admin/StudyGroups/EditGroupWebinar";
import GroupWebinars from "./containers/Admin/StudyGroups/GroupWebinars";
import Statistics from "./containers/Admin/StudyGroups/Statistics";
import GalleryContainer from "./containers/Gallery/Gallery";
import RepresentiveRequests from "./containers/RepresentiveRequests/index.jsx";
import JoinGroup from "./containers/JoinGroup/index.jsx";
import BecomeSuperhost from "./containers/BecomeSuperhost/index.jsx";
import CpdUserLocker from "./containers/CpdUser/CpdUserLocker.jsx";
import CpdUserLive from "./containers/CpdUser/CpdUserLive.jsx";
import CpdUserRecorded from "./containers/CpdUser/CpdUserRecorded.jsx";
import StudyGroupSuperhostAudioWebinar from "./components/StudyGroupSuperhost/StudyGroupSuperhostAudioWebinar";
import StudyGroupsUserAudioWebinar from "./components/StudyGroupsUser/StudyGroupsUserAudioWebinar/index.jsx";
import CpdSuperhostLocker from "./containers/CpdSuperhost/CpdSuperhostLocker.jsx";
import CpdSuperhostLive from "./containers/CpdSuperhost/CpdSuperhostLive.jsx";
import CpdSuperhostRecorded from "./containers/CpdSuperhost/CpdSuperhostRecorded.jsx";
import StudyGroupUserWrapper from "./containers/StudyGroups/StudyGroupUserWrapper.jsx";
import AllStudyGroupsUser from "./containers/StudyGroups/AllStudyGroupsUser.jsx";
import RequestToJoinGroup from "./containers/RequestToJoinGroup/index.jsx";
import StudyGroupSuperhostWrapper from "./containers/StudyGroupsSuperhost/StudyGroupSuperhostWrapper.jsx";
import AddGroupWebinarUsers from "./components/Admin/AddGroupWebinarUsers/index.jsx";
import AdminAddCertificates from "./containers/Admin/AddCertificates";
import SuperhostAddCertificates from "./containers/SuperhostAddCertificates";
import NotificationsPage from "./containers/NotificationsPage";
import LoginAdmin from "./containers/Authorization/LoginAdmin/index.jsx";
import LoginAdminConfirm from "./containers/Authorization/LoginAdminConfirm/index.jsx";
import EditStudyGroupSuperhost from "./containers/EditStudyGroupSuperhost/index.jsx";
import HostDashboard from "./containers/HostDashboard/index.jsx";
import SystemFeedbacks from "./containers/Admin/SystemFeedbacks/index.jsx";
import AddFeedback from "./containers/Admin/AddFeedback/index.jsx";
import EditFeedback from "./containers/Admin/EditFeedback/index.jsx";
import RegisterRequestConfirm from "./containers/RegisterRequestConfirm/index.jsx";

import ClientUrlsAdmin from "./containers/Admin/ClientUrls/ClientUrls.jsx";
import BlockedDates from "./containers/Admin/BlockedDates/BlockedDates.jsx";
import NewClientUrl from "./containers/Admin/ClientUrls/NewClientUrl.jsx";
import EditClientUrl from "./containers/Admin/ClientUrls/EditClientUrl.jsx";
import AddClientUrlsWebinars from "./containers/Admin/ClientUrls/AddWebinarsList.jsx";
import ClientUrlDashboard from "./containers/ClientUrlDashboard/Dashboard.js";

const {
  loadSponsorsSaga,
  loadPartnersSaga,
  // loadВisciplines,
} = actions;

class AppRouter extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadSponsors();
  }

  sponsorCustomRoutes = () => {
    const { sponsors } = this.props;
    const validSponsors = sponsors.filter((el) => !!el.namespace);

    return validSponsors.map((sponsor) => {
      return (
        <Route
          exact
          path={`/${sponsor.namespace}`}
          component={SponsorsDashboard}
        />
      );
    });
  };

  publicRoutes = () => [
    <Route exact path="/about_us" component={AboutUs} />,
    <Route exact path="/faq" component={FAQPageContainer} />,
    <Route exact path="/privacy_policy" component={PrivacyPolicy} />,
    <Route exact path="/terms_of_service" component={TermsOfService} />,
    <Route exact path="/cookie_policy" component={CookiePolicy} />,
    <Route exact path="/booking_webinar" component={CalendarSponsor} />,
    <Route
      path="/search"
      component={this.props.logged ? Search : GuestSearchPage}
    />,
  ];

  guestRoutes = () => [
    <Route exact path="/users/sign_in" component={Login} />,
    <Route exact path="/users/sign_in/admin" component={LoginAdmin} />,
    <Route
      exact
      path="/users/sign_in/admin/confirm"
      component={LoginAdminConfirm}
    />,
    <Route exact path="/users/sign_up" component={SignUp} />,
    <Route exact path="/users/forgot_password" component={ForgotPassword} />,
    <Route exact path="/unsubscribe_emails" component={Unsubscribe} />,
    <Route exact path="/update_passwords" component={NewPassword} />,
    <Route exact path="/" component={Landing} />,
    <Route exact path="/confirm_email*" component={ConfirmEmail} />,
    <Route
      path="/register-request-confirm"
      component={RegisterRequestConfirm}
    />,
    <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
    <Route exact path="/join_group/:id" component={JoinGroup} />,

    ...this.publicRoutes(),
  ];

  watchUrlRoutes = () => [
    <Route exact path="/webinars/:id" component={Login} />,
    ...this.guestRoutes(),
  ];

  loggedAsHospDoctorOrConsultant = () => [
    <Route exact path="/" component={Dashboard} />,
    // <Route exact path="/faculty" exact component={DashboardFaculty} />,
    <Route exact path="/users/profile" component={Profile} />,
    <Route exact path="/webinars/:id" component={OnlineWebinar} />,
    <Route exact path="/unsubscribe_emails" component={Unsubscribe} />,
    <Route
      path="/webinars/:id/feedback/:feedbackId"
      exact
      component={FeedbackContainer}
    />,

    <Route exact path="/join_group/:id" component={JoinGroup} />,
    <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
    ...this.sponsorCustomRoutes(),
    ...(this.props.isLoaded
      ? []
      : [<Route exact path="*" component={SponsorsRouteInterceptor} />]),
  ];

  loggedNotSponsor = () => [
    <Route exact path="/" component={Dashboard} />,
    <Route exact path="/notifications" component={NotificationsPage} />,
    <Route exact path="/cpd" component={CpdUserLocker}>
      <IndexRoute component={CpdUserLive} />
      <Route exact path="recorded" component={CpdUserRecorded} />
      <Route exact path="live" component={CpdUserLive} />
    </Route>,
    // <Route exact path="/faculty" exact component={DashboardFaculty} />,
    <Route exact path="/users/profile" component={Profile} />,
    <Route exact path="/groups" component={StudyGroupUserWrapper}>
      <IndexRoute component={StudyGroupsListUser} />
      <Route exact path="my" component={StudyGroupsListUser} />
      <Route exact path="all" component={AllStudyGroupsUser} />
    </Route>,
    <Route exact path="/groups/become-superhost" component={BecomeSuperhost} />,
    <Route
      path="/groups/request-to-join-group"
      exact
      component={RequestToJoinGroup}
    />,
    <Route exact path="/groups/:id" component={StudyGroupUserPage}>
      <Route exact path="resources" component={StudyGroupUserMaterials} />
      <Route
        path="resources/new"
        exact
        component={StudyGroupUserMaterialsNew}
      />
      <Route exact path="members" component={StudyGroupUserMembers} />
      <Route exact path="chat" component={StudyGroupUserChat} />
      <Route exact path="webinars" component={StudyGroupUserWebinars}>
        <Route exact path="current" component={StudyGroupUserCurrentWebinars} />
        <Route
          path="recorded"
          exact
          component={StudyGroupUserRecordedWebinars}
        />
        <Route
          path="upcoming"
          exact
          component={StudyGroupUserUpcomingWebinars}
        />
      </Route>
    </Route>,
    <Route
      path="/groups/:id/webinars/:webinarId"
      exact
      component={StudyGroupUserWebinar}
    />,
    <Route
      path="/groups/:id/webinars/:webinarId/audio"
      exact
      component={StudyGroupsUserAudioWebinar}
    />,
    <Route
      path="/groups/:id/webinars/:webinarId/feedback/:feedbackId"
      exact
      component={StudyGroupUserWebinarFeedback}
    />,
    <Route exact path="/unsubscribe_emails" component={Unsubscribe} />,
    <Route exact path="/webinars/:id" component={OnlineWebinar} />,
    <Route
      path="/webinars/:id/feedback/:feedbackId"
      exact
      component={FeedbackContainer}
    />,
    <Route exact path="/join_group/:id" component={JoinGroup} />,
    <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
    ...this.sponsorCustomRoutes(),
    ...(this.props.isLoaded
      ? []
      : [<Route exact path="*" component={SponsorsRouteInterceptor} />]),
  ];

  loggedRoutesForOther = () => [
    <Route exact path="/cpd" component={CpdLocker}>
      <IndexRoute component={CpdLive} />
      <Route exact path="recorded" component={CpdRecorded} />
      <Route exact path="live" component={CpdLive} />
    </Route>,
    <Route exact path="/" component={Dashboard} />,
    <Route exact path="/stats" component={StatsLocker} />,
    <Route
      exact
      path="/data-visualisation/:id"
      component={DataVisualisation}
    />,
    <Route exact path="/users/profile" component={Profile} />,
    <Route exact path="/unsubscribe_emails" component={Unsubscribe} />,
    <Route exact path="/webinars/:id" component={OnlineWebinar} />,
    <Route exact path="/calendar" component={CalendarSponsor} />,
    <Route exact path="/bookings" component={SponsorBookings} />,

    // <Route exact path="/booking_webinar" component={BookingWebinar}/>,
    <Route
      path="/webinars/:id/feedback/:feedbackId"
      exact
      component={FeedbackContainer}
    />,
    <Route exact path="/join_group/:id" component={JoinGroup} />,
    <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
    ...this.sponsorCustomRoutes(),
    ...(this.props.isLoaded
      ? []
      : [<Route exact path="*" component={SponsorsRouteInterceptor} />]),
  ];

  // loggedRepresentative = () => [
  //   <Route exact path="/cpd" component={CpdLocker}>
  //     <IndexRoute component={CpdLive} />
  //     <Route exact path="recorded" component={CpdRecorded} />
  //     <Route exact path="live" component={CpdLive} />
  //   </Route>,
  //   <Route exact path="/" exact component={Dashboard} />,
  //   <Route exact path="/stats" component={StatsLocker} />,
  //   <Route exact path="/data-visualisation/:id" component={DataVisualisation} />,
  //   <Route exact path="/users/profile" component={ProfileRepresentative} />,
  //   <Route exact path="/unsubscribe_emails" component={Unsubscribe} />,
  //   <Route exact path="/webinars/:id" component={OnlineWebinar} />,
  //   <Route exact path="/calendar" component={CalendarSponsor} />,
  //   <Route exact path="/bookings" component={SponsorBookings} />,
  //   // <Route exact path="/requests/pending" component={RepresentivePendingRequests} />,
  //   // <Route
  //   //   path="/requests/approved"
  //   //   component={RepresentiveNotPendingRequests}
  //   // />,
  //   // <Route exact path="/booking_webinar" component={BookingWebinar}/>,
  //   <Route
  //     path="/webinars/:id/feedback/:feedbackId"
  //     exact
  //     component={FeedbackContainer}
  //   />,
  //   <Route exact path="/join_group/:id" component={JoinGroup} />,
  //   <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
  //   ...this.publicRoutes(),
  //   ...this.sponsorCustomRoutes(),
  //   ...(this.props.isLoaded
  //     ? []
  //     : [<Route exact path="*" component={SponsorsRouteInterceptor} />]),
  // ];

  loggedRoutes = () => {
    // if (this.props.user.user_type === 'consultant') {
    //   return this.loggedAsHospDoctorOrConsultant();
    // } else
    // if (this.props.user.user_type === 'hospital_doctor') {
    //   return this.loggedAsHospDoctorOrConsultant();
    // } else
    if (this.props.user.user_type != "sponsor") {
      return this.loggedNotSponsor();
    }
    // if (this.props.user.is_representative) {
    //   return this.loggedRepresentative();
    // }
    return this.loggedRoutesForOther();
  };

  adminRoutes = () => [
    <Route exact path="/notifications" component={NotificationsPage} />,
    <Route exact path="/feedbacks" component={SystemFeedbacks} />,
    <Route exact path="/feedbacks/new" component={AddFeedback} />,
    <Route exact path="/feedbacks/:id" component={EditFeedback} />,
    <Route exact path="/feedbackform/:id" component={FeedbackEdit} />,
    <Route exact path="/webinars/new" component={NewWebinar} />,
    <Route exact path="/webinars" component={Webinars} />,
    <Route exact path="/webinars/:id" component={EditWebinar} />,
    <Route
      path="/webinars/:id/users"
      exact
      component={RegisteredUserForWebinar}
    />,

    <Route
      path="/webinars/:id/newsletter"
      exact
      component={NewsletterUsersContainer}
    />,
    <Route
      path="/webinars/:id/certificates"
      exact
      component={AdminAddCertificates}
    />,
    <Route exact path="/users" component={Users} />,
    <Route exact path="/users/new" component={NewUser} />,
    <Route exact path="/users/approve" component={ApproveUsers} />,
    <Route
      path="/users/novo-nordisk"
      exact
      component={NovoNordiskUsersContainer}
    />,
    <Route exact path="/users/approve-ipna" component={ApproveIpna} />,
    <Route exact path="/users/:id/edit" component={EditUser} />,
    <Route exact path="/users/:id/edit" component={EditUser} />,
    <Route exact path="/sponsors/new" component={NewSponsor} />,
    <Route exact path="/disciplines/new" component={NewDiscipline} />,
    <Route exact path="/sponsors" component={Sponsors} />,
    <Route exact path="/disciplines" component={Disciplines} />,
    <Route exact path="/sponsors/:id" component={EditSponsor} />,
    <Route exact path="/disciplines/:id" component={EditDiscipline} />,
    <Route exact path="/partnership/new" component={NewPartner} />,
    <Route exact path="/partnership" component={Partners} />,
    <Route exact path="/partnership/:id" component={EditPartner} />,
    <Route exact path="/users_sponsors" component={UsersSponsors} />,
    <Route exact path="/users_sponsors/new" component={NewUserSponsor} />,
    <Route exact path="/users_sponsors/:id/edit" component={EditUserSponsor} />,
    <Route exact path="/settings" component={AdminSettings} />,
    <Route exact path="/" component={StatisticsDashboard} />,
    // <Route exact path="/calendar" exact component={CalendarAdmin}/>,
    <Route exact path="/gallery" component={GalleryContainer} />,
    <Route exact path="/calendar" component={CalendarSponsor} />,
    <Route exact path="/calendar/approve_booking" component={ApproveBooking} />,
    <Route exact path="/calendar/pending_booking" component={PendingBooking} />,
    <Route
      path="/calendar/rejected_booking"
      exact
      component={RejectedBooking}
    />,
    <Route exact path="/calendar/edit_booking/:id" component={EditCalendar} />,

    <Route
      path="/calendar/rejected_booking"
      exact
      component={RejectedBooking}
    />,
    <Route exact path="/calendar/edit_booking/:id" component={EditCalendar} />,
    <Route exact path="/webinars/new/addUsers" component={AddUsersWebinar} />,
    <Route
      path="/webinars/:id/addUsers"
      exact
      component={EditAddUsersWebinar}
    />,
    <Route exact path="/groups" component={StudyGroups} />,
    <Route exact path="/groups/new" component={NewStudyGroup} />,
    <Route exact path="/groups/:id/edit" component={EditStudyGroup} />,
    <Route exact path="/groups/:id/webinars/new" component={NewGroupWebinar} />,
    <Route
      path="/groups/:id/webinars/:webinarId"
      exact
      component={EditGroupWebinar}
    />,
    <Route
      path="/groups/:id/webinars/new/addUsers"
      exact
      component={AddGroupWebinarUsers}
    />,
    <Route
      path="/groups/:id/webinars/edit/addUsers"
      exact
      component={AddGroupWebinarUsers}
    />,
    <Route
      path="/groups/:id/webinars/:webinarId/certificates"
      exact
      component={AdminAddCertificates}
    />,
    <Route exact path="/groups/:id" component={StudyGroupPage}>
      {/* <Route exact path="/groups" exact component={StudyGroups} />, */}
      <IndexRoute exact component={GroupWebinars} />,
      <Route exact path="course-materials" component={CourseMaterials} />,
      <Route exact path="webinars" component={GroupWebinars} />,
      <Route exact path="statistics" component={Statistics} />,
      <Route exact path="cpd" component={CourseMaterials} />,
      <Route exact path="members" component={GroupMembers} />,
      <Route exact path="members/add" component={AddGroupMembers} />,
    </Route>,
    <Route exact path="/superhosts" component={Superhosts} />,
    <Route exact path="/superhosts/new" component={NewSuperhost} />,
    <Route exact path="/superhosts/:id/edit" component={EditSuperhost} />,
    <Route exact path="/blocked_dates" component={BlockedDates} />,
    <Route exact path="/client-url" component={ClientUrlsAdmin} />,
    <Route exact path="/client-url/new" component={NewClientUrl} />,
    <Route exact path="/client-url/:id/edit" component={EditClientUrl} />,
    <Route
      exact
      path="/client-url/new/add-webinars"
      component={AddClientUrlsWebinars}
    />,
    <Route
      exact
      path="/client-url/:id/edit/add-webinars"
      component={AddClientUrlsWebinars}
    />,
  ];

  hostRoles = () => [
    <Route exact path="/feedbackform/:id" component={FeedbackEdit} />,
    <Route exact path="/webinars/new" component={NewWebinar} />,
    <Route exact path="/webinars" component={Webinars} />,
    <Route exact path="/webinars/:id" component={EditWebinar} />,
    <Route
      path="/webinars/:id/users"
      exact
      component={RegisteredUserForWebinar}
    />,

    <Route
      path="/webinars/:id/newsletter"
      exact
      component={NewsletterUsersContainer}
    />,
    <Route exact path="/users/new" component={NewUser} />,

    <Route exact path="/sponsors/new" component={NewSponsor} />,
    <Route exact path="/disciplines/new" component={NewDiscipline} />,
    <Route exact path="/sponsors" component={Sponsors} />,
    <Route exact path="/disciplines" component={Disciplines} />,
    <Route exact path="/sponsors/:id" component={EditSponsor} />,
    <Route exact path="/disciplines/:id" component={EditDiscipline} />,
    <Route exact path="/partnership/new" component={NewPartner} />,
    <Route exact path="/partnership" component={Partners} />,
    <Route exact path="/partnership/:id" component={EditPartner} />,
    <Route exact path="/users_sponsors" component={UsersSponsors} />,
    <Route exact path="/users_sponsors/new" component={NewUserSponsor} />,
    <Route exact path="/users_sponsors/:id/edit" component={EditUserSponsor} />,
    <Route exact path="/settings" component={AdminSettings} />,
    <Route exact path="/" component={HostDashboard} />,
    // <Route exact path="/calendar" exact component={CalendarAdmin}/>,
    <Route exact path="/gallery" component={GalleryContainer} />,
    <Route exact path="/calendar" component={CalendarSponsor} />,
    <Route exact path="/calendar/approve_booking" component={ApproveBooking} />,
    <Route exact path="/calendar/pending_booking" component={PendingBooking} />,
    <Route
      path="/calendar/rejected_booking"
      exact
      component={RejectedBooking}
    />,
    <Route exact path="/calendar/edit_booking/:id" component={EditCalendar} />,
    <Route exact path="/webinars/new/addUsers" component={AddUsersWebinar} />,
    <Route
      path="/webinars/:id/addUsers"
      exact
      component={EditAddUsersWebinar}
    />,
  ];

  superhostRoutes = () => [
    <Route exact path="/webinars/new" component={NewWebinar} />,
    <Route exact path="/webinars" component={Webinars} />,
    <Route exact path="/webinars/:id" component={OnlineWebinar} />,
    <Route exact path="/notifications" component={NotificationsPage} />,
    <Route
      path="/webinars/:id/feedback/:feedbackId"
      exact
      component={FeedbackContainer}
    />,
    <Route exact path="/disciplines/new" component={NewDiscipline} />,
    <Route exact path="/disciplines" component={Disciplines} />,
    <Route exact path="/disciplines/:id" component={EditDiscipline} />,
    <Route exact path="/settings" component={AdminSettings} />,
    <Route exact path="/" component={Dashboard} />,
    <Route exact path="/cpd" component={CpdSuperhostLocker}>
      <IndexRoute component={CpdSuperhostLive} />
      <Route exact path="recorded" component={CpdSuperhostRecorded} />
      <Route exact path="live" component={CpdSuperhostLive} />
    </Route>,
    <Route exact path="/users/profile" component={Profile} />,
    <Route exact path="/faq" component={FAQPageContainer} />,
    // <Route exact path="/calendar" exact component={CalendarAdmin}/>,
    <Route exact path="/calendar" component={CalendarSponsor} />,
    <Route exact path="/calendar/approve_booking" component={ApproveBooking} />,
    <Route exact path="/calendar/pending_booking" component={PendingBooking} />,
    <Route
      path="/calendar/rejected_booking"
      exact
      component={RejectedBooking}
    />,
    <Route exact path="/calendar/edit_booking/:id" component={EditCalendar} />,
    <Route exact path="/feedbackform/:id" component={FeedbackEdit} />,
    <Route
      path="/groups/request-to-join-group"
      exact
      component={RequestToJoinGroup}
    />,
    // <Route exact path="/groups" exact component={StudyGroupsSuperhost} />,
    <Route exact path="/groups" component={StudyGroupSuperhostWrapper}>
      <IndexRoute component={StudyGroupsSuperhost} />
      <Route exact path="my" component={StudyGroupsSuperhost} />
      <Route exact path="all" component={AllStudyGroupsUser} />
    </Route>,
    // <Route exact path="/groups/new" exact component={NewStudyGroup} />,
    <Route exact path="/groups/:id/edit" component={EditStudyGroupSuperhost} />,
    <Route exact path="/groups/:id" component={StudyGroupSuperHostPage}>
      <Route exact path="resources" component={StudyGroupSuperhostMaterials} />
      <Route
        path="resources/new"
        exact
        component={StudyGroupUserMaterialsNew}
      />
      <Route
        path="resources/:materialId/edit"
        exact
        component={StudyGroupSuperhostEditMaterialForm}
      />
      <Route
        path="webinars/new/addUsers"
        exact
        component={StudyGroupSuperhostAddWebinarUsers}
      />
      <Route
        path="webinars/:webinarId/edit"
        exact
        component={StudyGroupSuperhostEditWebinar}
      />
      <Route
        path="webinars/:webinarId/users"
        exact
        component={RegisteredUserForWebinar}
      />
      <Route
        path="webinars/:webinarId/edit/addUsers"
        exact
        component={StudyGroupSuperhostAddWebinarUsers}
      />
      <Route
        path="webinars/:webinarId/certificates"
        exact
        component={SuperhostAddCertificates}
      />
      <Route
        path="webinars/all"
        exact
        component={StudyGroupSuperhostWebinars}
      />
      <Route
        path="webinars"
        exact
        component={StudyGroupSuperhostWebinarsWrapper}
      >
        <Route
          path="upcoming"
          exact
          component={StudyGroupSuperhostUpcomingWebinars}
        />
        <Route
          path="recorded"
          exact
          component={StudyGroupSuperhostRecordedWebinars}
        />
        <Route
          path="current"
          exact
          component={StudyGroupSuperhostCurrentWebinars}
        />
      </Route>
      <Route exact path="members" component={StudyGroupSuperhostMembers} />
      <Route
        path="members/new"
        exact
        component={StudyGroupSuperhostInviteMembers}
      />
      <Route exact path="chat" component={StudyGroupUserChat} />
      <Route exact path="statistics" component={StudyGroupSuperhostStatistic} />
    </Route>,
    <Route
      path="/groups/:id/webinars/new"
      exact
      component={StudyGroupSuperhostAddWebinar}
    />,
    <Route
      path="/groups/:id/webinars/:webinarId"
      exact
      component={StudyGroupUserWebinar}
    />,
    <Route
      path="/groups/:id/webinars/:webinarId/audio"
      exact
      component={StudyGroupsUserAudioWebinar}
    />,
    <Route
      path="/groups/:id/webinars/:webinarId/feedback/:feedbackId"
      exact
      component={StudyGroupUserWebinarFeedback}
    />,
  ];

  unconfirmedRoutes = () => [
    <Route exact path="/" component={ConfirmEmailView} />,
    <Route exact path="/confirm_email*" component={ConfirmEmail} />,
    <Route exact path="/join_group/:id" component={JoinGroup} />,
    <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
  ];

  unfilledProfileRoutes = () => [
    <Route exact path="/users/profile" component={Profile} />,
    <Route exact path="/join_group/:id" component={JoinGroup} />,
    <Route exact path="/join_webinar/:id" component={JoinWebinar} />,
    ...this.publicRoutes(),
  ];

  sharedRoutes = () => [];

  routes = () => {
    let routesToRender;
    let emailConfirmedNotAdmin =
      this.props.emailConfirmed &&
      ["admin", "host"].indexOf(this.props.role) < 0;
    if (this.props.logged) {
      routesToRender = this.loggedRoutes;
      if (this.props.role === "admin") {
        routesToRender = this.adminRoutes;
      }
      if (this.props.role === "superhost") {
        routesToRender = this.superhostRoutes;
      }
      if (this.props.role === "host") {
        routesToRender = this.hostRoles;
      }
      if (!this.props.emailConfirmed && this.props.role !== "admin") {
        routesToRender = this.unconfirmedRoutes;
      }
      if (
        (!this.props.user.is_valid && emailConfirmedNotAdmin) ||
        (emailConfirmedNotAdmin &&
          !(
            this.props.user.disciplines && this.props.user.disciplines.length
          ) &&
          this.props.user.user_type !== "sponsor" &&
          this.props.user.user_type !== "host" &&
          this.props.user.user_type !== "industry")
      ) {
        routesToRender = this.unfilledProfileRoutes;
      }
    } else {
      if (
        [
          "/users/sign_in",
          "/users/sign_up",
          "/users/forgot_password",
          "user/unsubscribe_emails",
        ].indexOf(window.location.pathname) === -1
      ) {
        localStorage.setItem("nonLoggedInUrl", window.location.pathname);
      }
      routesToRender = this.watchUrlRoutes;
    }

    return routesToRender();
  };

  rootPath = () => {
    const { logged, user, role } = this.props;

    if (logged) {
      if (role === "host") return "/";
      if (
        role !== "admin" &&
        user.user_type !== "sponsor" &&
        user.user_type !== "industry" &&
        user.email_confirmed &&
        !(user.disciplines && user.disciplines.length)
      ) {
        return "/users/profile";
      }
      if (!!user.is_valid || !user.email_confirmed) {
        return "/";
      }
      return "/users/profile";
    }
    return "/users/sign_in";
  };

  render() {
    return (
      <div>
        {this.props.children}
        <ReduxRouter>
          <Route exact component={App}>
            {this.routes()}
            {this.sharedRoutes()}
            {/* {dynamicRoutes.map((route => (
              <Route exact path={`/${route.slug}`} component={Login} key={`dynamic-route-${route.id}`} />
            )))} */}
            <Route
              exact
              path="/join_qr_webinar/:id"
              component={JoinQRCodeWebinar}
            />
            ,
            <Redirect path="/vhi360" to="/webinars/778" />
            <Redirect path="/sign_up" to="/users/sign_up" />
            <Route path="/:slug" component={ClientUrlDashboard} />,
            <Redirect from="*" to={`${this.rootPath()}`} />
          </Route>
        </ReduxRouter>
      </div>
    );
  }
}

AppRouter.PropTypes = {
  logged: PropTypes.boolean,
};

function mapStateToProps(state) {
  return {
    logged: !!(state.users.user && state.session && state.session.token),
    role: state.users.user.role,
    emailConfirmed: state.users.user.email_confirmed,
    user: state.users.user,
    sponsors: state.sponsors.list.values,
    isLoaded: state.sponsors.list.isLoaded,
    isLoadedRoutes: state.clientUrls.list.isLoaded,
    dynamicRoutes: state.clientUrls.list.values,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadSponsors: () => dispatch(loadSponsorsSaga()),
    loadPartners: () => dispatch(loadPartnersSaga()),
    loadUsersSponsors: () => dispatch(loadSponsorsSaga()),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);



// WEBPACK FOOTER //
// ./src/routes.js